import { createRef, useCallback, useEffect } from 'react';

// Place this component at the bottom of your infinite list of things
// Any time it comes on screen, the onOnScreen callback gets called
// which should load more items and push this component back offscreen.

export const CbInfiniteScroll = ({
  onOnScreen
}: {
  onOnScreen: () => any;
}) => {
  const endRef = createRef<HTMLDivElement>();
  const callback = useCallback((entries: IntersectionObserverEntry[]) => {
    if (!entries.some(e => e.isIntersecting)) return;
    onOnScreen();
  }, [onOnScreen]);
  useEffect(() => {
    if (!endRef.current) return;
    const elt = endRef.current;
    const observer = new IntersectionObserver(callback, {
      root: null,
      rootMargin: '0px',
      threshold: 0.01
    });
    observer.observe(elt);
    return () => {
      observer.unobserve(elt);
    };
  }, [endRef, callback]);
  return <div ref={endRef} data-sentry-component="CbInfiniteScroll" data-sentry-source-file="CbInfiniteScroll.tsx"></div>;
};